import { useRef } from 'react';
import { Trans } from '@lingui/macro';
import { Box, Flex, Stack, Text } from '@mantine/core';

import { TDiscountRules } from '../../domains/buy-ticket/types';
import { UiNmberClickerInput } from '../ui/ui-number-clicker-input/ui-number-clicker-input';

type Tariff = {
  id: number;
  price: number;
  tariffTypeId: number;
  name: string;
  descr: string;
  maxCountPerTicket: number; // if value === 0, then no restrictions
  main: boolean;
  discountRules: TDiscountRules[] | null;
};

type CalculatedTariff = {
  id: number;
  price: number;
  count: number;
  main: boolean;
  discountRules: TDiscountRules[] | null;
};

const NO_RESTRICTION_MAX_COUNT_PER_TICKET = 0;

type CalcSumType = {
  price: number;
  id: number;
  main: boolean;
  discountRules: TDiscountRules[] | null;
};

export const TicketsCount = ({
  values,
  tariffs,
  onCalculate,
}: {
  values?: CalculatedTariff[];
  tariffs: Tariff[];
  onCalculate: (tariffs: CalculatedTariff[]) => void;
}) => {
  const currencyRef = useRef(new Map());

  const calcSum =
    ({ price, id, main, discountRules }: CalcSumType) =>
    (value: number) => {
      currencyRef.current.set(id, { count: value, price, main, discountRules });

      const result: CalculatedTariff[] = [];

      currencyRef.current.forEach((value, key) => {
        result.push({
          id: key,
          price: value.price,
          count: value.count,
          main: value.main,
          discountRules: value.discountRules,
        });
      });

      onCalculate(result);
    };

  if (tariffs.length === 0)
    return (
      <Text>
        <Trans>Не найдены билеты с тарифами по выбранному маршруту.</Trans>
        <br /> <Trans>Попробуйте проверить или выбрать другой маршрут</Trans>
      </Text>
    );

  return (
    <Stack>
      {tariffs.map((tariff) => (
        <Flex key={tariff.id} justify="space-between" align="center">
          <span>{tariff.name}:</span>
          <Box miw={150}>
            <UiNmberClickerInput
              value={values?.find((value) => value.id === tariff.id)?.count}
              min={0}
              max={
                tariff.maxCountPerTicket === NO_RESTRICTION_MAX_COUNT_PER_TICKET
                  ? undefined
                  : tariff.maxCountPerTicket
              }
              step={1}
              onChange={calcSum({
                price: tariff.price,
                id: tariff.id,
                main: tariff.main,
                discountRules: tariff.discountRules,
              })}
            />
          </Box>
        </Flex>
      ))}
    </Stack>
  );
};
